import React, { useState } from 'react';
import { Card, Row, Col } from 'antd';
import ViewForm from './components/ViewForm';
import { BASE_URL } from '../../constants';
import FormTable from '../../components/FormTable';
import Hyperlink from '../../components/Hyperlink';

const Form = () => {
  const [viewFormOpen, setViewFormOpen] = useState(false);
  const [selectedForm, selectForm] = useState({});

  const columns = [
    {
      title: 'Token',
      dataIndex: 'token',
      key: 'token',
    },
    {
      title: 'Agency',
      dataIndex: 'agencyName',
      key: 'agencyName',
    },
    {
      title: 'Agency Ref. No.',
      dataIndex: 'agencyUniqueReference',
      key: 'agencyUniqueReference',
      render: (text) => (!text ? 'N / A' : text),
    },
    {
      title: 'Date',
      dataIndex: 'tokenDate',
      key: 'tokenDate',
      render: text => <div>{new Date(text).toLocaleDateString()}</div>,
    },

    {
      title: 'Recipient Name',
      dataIndex: 'recipientName',
      key: 'recipientName',
    },
    {
      title: 'Recipient Email',
      dataIndex: 'recipientEmail',
      key: 'recipientEmail',
    },
    {
      title: 'Recipient Phone',
      dataIndex: 'recipientPhone',
      key: 'recipientPhone',
    },
    {
      title: 'Amount',
      key: 'amount',
      dataIndex: 'amount',
      render: amount => <span>GHc {Number(amount).toFixed(2)}</span>,
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Hyperlink
            icon="eye"
            onClick={() => {
              selectForm(record);
              setViewFormOpen(true);
            }}
          >
            View
            {record.name}
          </Hyperlink>
        </span>
      ),
    },
  ];

  return (
    <>
      <Row>
        <Col span={24}>
          <Card title="Generated Tokens">
            <FormTable
              dataSource={`${BASE_URL}/api/forms`}
              columns={columns}
            />
          </Card>
        </Col>
      </Row>

      <ViewForm
        isShown={viewFormOpen}
        token={selectedForm}
        onCloseComplete={() => setViewFormOpen(false)}
        width="500px"
      />
    </>
  );
};

export default Form;
